import { DialogService } from 'primeng/dynamicdialog';
import { MenuItem, PrimeIcons } from 'primeng/api';
import { CompareDialogComponent } from './compare-dialog.component';

export interface CompareColumnDefinition {
  field: string;
  header: string;
}

const MD_FIELDS = ['measuredDepth', 'md', 'mdFt'];
const TVD_FIELDS = ['trueVerticalDepth', 'tvd', 'tvdFt'];

export function getDepthColumns(columnDefinitions: CompareColumnDefinition[]) {
  const mdCol = columnDefinitions.find(c => MD_FIELDS.includes(c.field));
  const tvdCol = columnDefinitions.find(c => TVD_FIELDS.includes(c.field));
  return { mdCol, tvdCol };
}

export function isDepthColumn(field: string, columnDefinitions: CompareColumnDefinition[]): boolean {
  const { mdCol, tvdCol } = getDepthColumns(columnDefinitions);
  return !!((mdCol && field === mdCol.field) || (tvdCol && field === tvdCol.field));
}

export function shouldSkipCompareForTable(tableName: string, blockedTableNames: string[]): boolean {
  return blockedTableNames.includes(tableName);
}

export function createCompareContextMenuItems(command: () => void): MenuItem[] {
  return [
    {
      label: 'Compare Values',
      icon: PrimeIcons.CHART_LINE,
      command
    }
  ];
}

export function openCompareDialog(
  dialogService: DialogService,
  col: CompareColumnDefinition,
  columnDefinitions: CompareColumnDefinition[],
  gridData: any[]
): void {
  const { mdCol, tvdCol } = getDepthColumns(columnDefinitions);
  const depthModeOptions: { label: string; value: string }[] = [];
  if (mdCol) {
    depthModeOptions.push({ label: 'MD', value: 'md' });
  }
  if (tvdCol) {
    depthModeOptions.push({ label: 'TVD', value: 'tvd' });
  }
  const depthMode = mdCol ? 'md' : 'tvd';

  dialogService.open(CompareDialogComponent, {
    header: `Compare: ${col.header}`,
    draggable: true,
    resizable: true,
    closable: true,
    style: { width: '950px', height: '600px' },
    data: {
      compareColumnHeader: col.header,
      depthModeOptions,
      depthMode,
      gridData,
      compareColumnField: col.field,
      mdField: mdCol?.field ?? '',
      tvdField: tvdCol?.field ?? '',
      mdHeader: mdCol?.header ?? '',
      tvdHeader: tvdCol?.header ?? ''
    }
  });
}